export default __webpack_public_path__ + "static/media/logo-zad.29b03cf3.png";